function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 16.8h0a6.11 6.11 0 016.27 6.2 6.1 6.1 0 01-6.19 6.23H32A6.1 6.1 0 0125.83 23 6.11 6.11 0 0132 16.8z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.05
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.05 2.28A20.86 20.86 0 0152.79 23a19.93 19.93 0 01-3.55 12.35c-2.81 4.43-17.2 25-17.2 25s-14.38-20.56-17.2-25A19.93 19.93 0 0111.31 23 20.86 20.86 0 0132.05 2.28z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.05
});

function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+bWFwLXBpbjwvdGl0bGU+PHBhdGggZD0iTTMyLDE2LjhoMEE2LjExLDYuMTEsMCwwLDEsMzguMjcsMjNhNi4xLDYuMSwwLDAsMS02LjE5LDYuMjNIMzJBNi4xLDYuMSwwLDAsMSwyNS44MywyMyw2LjExLDYuMTEsMCwwLDEsMzIsMTYuOFoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC4wNSIvPjxwYXRoIGQ9Ik0zMi4wNSwyLjI4QTIwLjg2LDIwLjg2LDAsMCwxLDUyLjc5LDIzYTE5LjkzLDE5LjkzLDAsMCwxLTMuNTUsMTIuMzVjLTIuODEsNC40My0xNy4yLDI1LTE3LjIsMjVzLTE0LjM4LTIwLjU2LTE3LjItMjVBMTkuOTMsMTkuOTMsMCwwLDEsMTEuMzEsMjMsMjAuODYsMjAuODYsMCwwLDEsMzIuMDUsMi4yOFoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC4wNSIvPjwvc3ZnPg==";
export { SvgMapPin as ReactComponent };